import { ModalProvider } from "@/providers/ModalProvider";
import { TooltipProvider } from "@/providers/TooltipProvider";
import { FeatureFlagsProvider } from "@/hooks/useFeatureFlags";

export const Providers = ({ children }: { children: React.ReactNode }) => {
  return (
    <TooltipProvider>
      <FeatureFlagsProvider>
        <ModalProvider>{children}</ModalProvider>
      </FeatureFlagsProvider>
    </TooltipProvider>
  );
};
